// let visible = true;
export default {
  name: 'menuItem',
  props: {
    currentRoute: {
      type: Object,
      required: true
    },
    customerId: {
      type: Number
    }
  },
  methods: {
    menuClick() {
      this.$store.dispatch('message/getSystemForcePopMessageList', {});
    },
    visibleChange2() {},
    visibleChange(val, remark) {
      console.log(val, 222);
      // visibleChange2();
      if (remark) {
        return val || false;
      } else {
        return false;
      }

      // val.visible = true;
      // console.log(val,this.currentRoute,data);

      // visible=true;
      // console.log(val,visible);
    }
  }

  // functional: true,
  // render (createElement, {children}) {
  //   console.log( createElement);
  //   return createElement('button', children);
  // }
};